import React, { useEffect, useState } from "react";
import Header from "../sections/Header";
import styles from "../../scss/layout/layout.module.scss";
import { IStoreDesignData } from "../../interfaces/StoreInterface";
import { setStoreData } from "../../redux/StoreData/StoreDataSlice";
import useFetch from "../../customHook/useFetch";
import { DIRECT_ACCESS_URL } from "../../constants/constants";
import { useDispatch } from "react-redux";
import { setStoreDesignListSlice } from "../../redux/StoreDesignList/StoreDesignListSlice";
import moment from "moment";
import FooterSection from "../sections/FooterSection";

const SimpleLayout = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useDispatch();
  const [loader, setloader] = useState(true);
  const [expired, setExpired] = useState(false);
  const [storeDesignData, setStoreDesignData] =
    useState<IStoreDesignData | null>(null);
  const [commingPage, setCommingPage] = useState(false);
  const [storeNotFound, setStoreNotFoundPage] = useState(false);

  const direct_access_url = DIRECT_ACCESS_URL;
  const [
    getStoreInfo,
    { response: getStorInfoRes, error: getStorInfoError, loading },
  ] = useFetch(`/get-store-info/${direct_access_url}`, {
    method: "get",
  });

  useEffect(() => {
    /** Checks For handle store info response  */
    if (getStorInfoRes) {
      if (getStorInfoRes?.status) {
        dispatch(setStoreData(getStorInfoRes?.data));
        if (
          getStorInfoRes?.data?.open_date_time &&
          new Date(getStorInfoRes?.data?.open_date_time * 1000) > new Date()
        ) {
          setCommingPage(true);
          // setOpenDate(getStorInfoRes?.data?.open_date_time);

          // localStorage.setItem(
          //   getStorInfoRes?.data?.open_date_time,
          //   "openDate"
          // );
          // navigate("/coming-soon", {
          //   state: getStorInfoRes?.data?.open_date_time,
          // });
        } else if (getStorInfoRes?.data?.close_date_time) {
          const currentDate = moment();
          const closeDateTm = moment.unix(
            getStorInfoRes?.data?.close_date_time
          );
          if (currentDate.diff(closeDateTm, "milliseconds") > 0) {
            setExpired(true);
          }
        } else if (getStorInfoRes?.data?.status === 2) {
          setExpired(true);
        } else if (getStorInfoRes?.status && getStorInfoRes?.code === 404) {
          setStoreNotFoundPage(true);
        }

        dispatch(
          setStoreDesignListSlice({
            ...getStorInfoRes?.data?.store_design_settings,
            is_team_available: getStorInfoRes?.data?.is_team_available,
          })
        );
        setStoreDesignData(getStorInfoRes?.data);
        setloader(false);
      }
    } else if (getStorInfoError) {
      dispatch(setStoreData({ data: {} }));
      setStoreNotFoundPage(true);
      // navigate("/store-not-found");
    }
  }, [getStorInfoRes, getStorInfoError]);

  return (
    <div className={styles.layout}>
      <Header
        headerOnly={expired}
        logo={storeDesignData?.store_design_settings?.club_logo}
        data={storeDesignData?.store_design_settings}
        loading={loading}
      />
      {children}
    </div>
  );
};

export default SimpleLayout;
